import shallow from "zustand/shallow";
import { useNavigate } from "react-router-dom";

import { useStoreSystem } from "../../store";
import Save from "../SVGasComponent/Save";
import styles from "./saveButton.module.scss";
import { useCurrentSearchParam } from "../../utils/hooks/useCurrentSearchParam";
import { API } from "../../controllers";
import { useAlerts } from "../../hooks/useAlerts";
import { useSaveProject } from "../../hooks/useSaveProject";
import { useLoading } from "../../hooks/useLoading";

export const SaveButton = () => {
    const { setSaveProjectModal, currentProjectUserId, userId, setUserId } = useStoreSystem(
        (state) => ({
            setSaveProjectModal: state.setSaveProjectModal,
            currentProjectUserId: state.currentProjectUserId,
            setUserId: state.setUserId,
            userId: state.userId,
        }),
        shallow
    );

    const saveProject = useSaveProject();
    const [hash] = useCurrentSearchParam("hash");
    const { setIsLoading } = useLoading();

    const onSaveProjectHandler = async () => {
        try {
            let currentUserId = userId;
            setIsLoading(true);

            if (!currentUserId || currentUserId !== userId) {
                currentUserId = await API.Bitrix.getUserId();
                setUserId(currentUserId);
            }

            /**
             * Открытие модального окна перезаписи либо создания нового проекта
             */
            if (hash && currentProjectUserId && currentUserId && currentProjectUserId === currentUserId) {
                setSaveProjectModal(true, "saveAs");
                return;
            }
            /**
             * Сохранение нового проекта,
             */
            if (currentUserId !== 0 && (!hash || currentProjectUserId !== currentUserId)) {
                await saveProject({});
            } else {
                /**
                 * Сохранение(обновление) с авторизацией / без авторизации
                 */
                setSaveProjectModal(true);
            }
        } catch (e) {
            console.error(e, ": Ошибка сохранения проекта");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div onClick={onSaveProjectHandler} className={styles.main}>
            <Save />
        </div>
    );
};
